import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';
import { ButtonSize } from '@wix/da-ds/pkg/Buttons/types';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import { DeviationResourceType } from '../../../types/deviation';
import { BiData, TierViewButtonBiEvent } from '@wix/da-bi/pkg/events';

export interface Props {
  tier: PapiDeviation;
  className?: string;
  size?: ButtonSize;
}
const ViewVariant: React.FC<Props> = ({ tier, className, size = 'medium' }) => {
  const { t } = useTranslation();
  return (
    <GhostButton
      className={className}
      size={size}
      variant="main"
      href={Url.userSubscriptionsPath({
        username: tier.author!.username,
        tierDeviationId: tier.deviationId,
        tierContentType: 'deviations',
      })}
      biData={BiData<TierViewButtonBiEvent>({
        evid: 544,
        typeid: DeviationResourceType.TIER,
        itemid: tier.deviationId,
      })}
    >
      {t('deviation.tier.viewSubscription')}
    </GhostButton>
  );
};
ViewVariant.displayName = 'ViewVariant';

export default ViewVariant;
